var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcFavorite = function SvgIcFavorite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "13px",
    viewBox: "0 0 15 13",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "5897ACE0-92C3-4EDD-8DC1-F447DE1380DA")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "film",
    transform: "translate(-308.000000, -618.000000)",
    fill: "#12100B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(41.000000, 255.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button_Secondary",
    transform: "translate(239.000000, 349.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(28.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button_icon",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6625971,2.30247163 C12.8024972,1.4660514 11.6537181,1.00537438 10.4328524,1.00537438 C9.35072142,1.00537438 8.32408435,1.36768111 7.50277469,2.03262434 C6.68146504,1.3644553 5.64927858,1 4.56714761,1 C3.3518313,1 2.20310766,1.45960085 1.33740289,2.29440899 C0.477247503,3.13029222 0,4.24301137 0,5.42668653 C0,6.60713587 0.477247503,7.71931748 1.34295228,8.55735197 L6.57602664,13.6274804 C6.82574917,13.8677627 7.15871254,14 7.50832408,14 C7.85238624,14 8.190899,13.8639999 8.43512764,13.6269434 L13.6625971,8.56595216 C14.5227525,7.73060594 15,6.6195005 15,5.43528618 C15,4.24999946 14.5283019,3.13781785 13.6625971,2.30247163 Z M2.37513873,7.56127965 C1.78129856,6.9898688 1.45948946,6.23139266 1.45948946,5.42668653 C1.45948946,4.62359357 1.78129856,3.86565444 2.36958935,3.2931685 C2.95776915,2.72390783 3.74028857,2.41051828 4.572697,2.41051828 C5.39955605,2.41051828 6.18756937,2.72498292 6.77574917,3.29531814 L6.99223085,3.50388633 C7.26415094,3.76835871 7.75249723,3.76889625 8.02436182,3.50442334 L8.22968923,3.30176923 C8.82352941,2.73089592 9.60599334,2.41643128 10.4384018,2.41643128 C11.2708102,2.41643128 12.0532741,2.72982029 12.63596,3.29908096 C13.2241398,3.86888025 13.5516093,4.62628184 13.5516093,5.43260007 C13.5516093,6.23730458 13.2241398,6.99470617 12.63596,7.56611702 L7.50832408,12.5325008 L2.37513873,7.56127965 Z",
    id: "ic_favorite"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcFavorite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_favorite.d9afbc22.svg";
export { ForwardRef as ReactComponent };